<div class="">
  <nav class="navbar navbar-expand-lg navbar-light">
    <form class="col form-inline my-2 my-lg-0">
      <input type="text" class="form-control" pInputText size="30" placeholder="Search Name"
        [formControl]='searchControl' (keyup.enter)="getData()" />
      <span type='submit' class="ui-dropdown-filter-icon pi pi-search" style="margin-inline-start: -30px;"></span>
    </form>
    <p-calendar placeholder='Select Date' #range_Dates="ngModel" id="rangeDates" inputId="range_date"
      [(ngModel)]="rangeDates" inputId='rangeDates' yearRange="2000:2030" selectionMode="range" [monthNavigator]="true"
      [yearNavigator]="true" [readonlyInput]="true" [showButtonBar]="true" (onClickOutside)="getData()"
      (onClose)="getData()" (onClearClick)="getData()" #calendar>
    </p-calendar>
  </nav>
</div>

<div class=''>
  <div class="overlay-container">
    <div class="text-center loader" *ngIf="(referralsData$|async).loaders.referrers">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <span>
      <table class="table table-primary">
        <thead class="">
          <tr>
            <th>
              <a (click)="getData({ salt: true })" id='refresh-button' class="pl-3" data-toggle="tooltip"
                title="Refresh referrals">
                <i class="fa fa-refresh fa-lg" aria-hidden="true"></i>
              </a>
            </th>
            <th>Promoter</th>
            <th>Phone</th>
            <th>District</th>
            <th>Farmers activated</th>
            <th>Commission</th>
            <th>Registered</th>
            <th>Last Referral Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf='(referralsData$|async).referrers.length===0' style="min-height: 50vh;">
            <td colspan="4">
            </td>
            <td width="100">No data</td>
          </tr>
          <tr
            *ngFor="let item of (referralsData$|async).referrers|paginate: { itemsPerPage: limit, currentPage: activePage, totalItems: (referralsData$|async).totalReferrers };let i=index">
            <td>
              {{i+1}}
            </td>
            <td>
              <div class="font-weight-bold">{{item.name}}</div>
            </td>
            <td>{{item.user_contact}}</td>
            <td>{{item.district||'NA'}}</td>
            <td>{{item.farmers_activated}}</td>
            <td>{{item.farmers_activated*(commissionRate$|async)}}</td>
            <td>{{(item.created_at | date)||'NA'}}</td>
            <td>{{(item.last_referral | date)||'NA'}}</td>

            <td>
              <button class='btn btn-outline-light' [routerLink]="[item.user_contact]">View Details</button>
            </td>
          </tr>
        </tbody>
      </table>
    </span>
  </div>
  <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true" class="justify-content-center"
    (pageChange)="displayActivePage($event)">
  </pagination-controls>
</div>